
export interface OneIdInstance {
    on: (event, listener) => void;
    off: (event, listener) => void;
    getGuest: () => Promise<OneIdResponse<Guest>>;
    getGuestNewsletters: () => Promise<OneIdResponse<OneIdNewsletter[]>>;
    getInlineNewsletters: (campaignId, options) => Promise<OneIdResponse<OneIdNewsletter>>;
    launchNewsletters: (campaignId, optionalConfig) => Promise<void>;
    setInlineNewsletters: (data, options) => Promise<void>;
    launchLogin: () => Promise<string>;
    getLoggedInStatus: () => Promise<boolean>;
    getTrustStateStatus: () => Promise<number>;
}
export interface OneIdConfig {
    clientId: string;
    responderPage: string;
    cssOverride?: string;
    debug?: boolean;
    scheme?: string;
    logLevel?: string;
}

export interface OneIdResponse<T> {
    data: T;
    /* eslint-disable-next-line camelcase */
    error_codes?: string;
}

export interface OneIdNewsletter {
    campaignId: string;
    email: string;
    marketing: OneIdNewsletterMarketingEntry[];
    legal?: OneIdNewsletterLegalEntry[];
}

export interface OneIdNewsletterLegalEntry {
    code: string;
    accepted: boolean;
    requiresActiveConsent?: boolean;
    content?: string;
}

export interface OneIdNewsletterMarketingEntry {
    code: string;
    subscribed: boolean;
    preselected?: boolean;
    content?: string;
}

export interface OneIdNewsletterRequest {
    campaignId: string;
    email: string;
    marketing: OneIdNewsletterMarketingEntry[];
    legal: OneIdNewsletterLegalEntry[];
}

export interface GuestInfo {
    name: string;
    lastName: string;
    swid: string;
    avatar?: string;
    passiveId?: string;
}

export interface Guest {
    profile: GuestProfile;
    marketing: GuestMarketing[];
}

export interface GuestProfile {
    swid: string;
    referenceId: string;
    username?: string;
    prefix?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffix?: string;
    languagePreference?: string;
    email: string;
    parentEmail?: string;
    dateOfBirth?: string;
    gender?: string;
    status?: string;
}

export interface GuestMarketing {
    code: string;
    subscribed: boolean;
    status: string;
    textID?: string;
}

export interface OneIdOptions {
    context?: string;
    source?: string;
    custom1?: string;
    custom2?: string;
    custom3?: string;
    custom4?: string;
    custom5?: string;
    custom6?: string;
    custom7?: string;
    custom8?: string;
}

export enum EmailCaptureStyle {
    INLINE = 'inline',
    MODAL = 'modal',
}

export enum EmailCaptureStatus {
    UNKNOWN = 1,
    UNSUBSCRIBED_GUEST,
    SUBSCRIBED_GUEST,
}

export interface OneIdUIResult  {
    result?: string | boolean;
    status?: EmailCaptureStatus;
    hasError: boolean;
}
